import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { findCPOnTrade } from "../../tradeLookupHelpers";

import {
  calculateQuotedPercentForER,
  calculateQuotedPercentForLeg,
} from "./quotedPercentHelpers";
import PercentBar from "@/components/UI/PercentBar";

const QuotedPercentCellRenderer = (params: any) => {
  const { fullTradeData, isOp, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData?.esid,
  );

  const liveLegs = resolveLiveLegs(thisTrade, params, isOp, isER);
  const fallbackLegs = params.data?.legs;

  let percent: number | null = null;

  if (isER) {
    percent = calculateQuotedPercentForER(liveLegs ?? fallbackLegs ?? []);
  } else {
    const liveLeg = liveLegs?.find(
      (leg: any) => leg.blockId == params.data?.blockId,
    );
    percent = calculateQuotedPercentForLeg(liveLeg ?? params.data);
  }

  if (percent === null) {
    return <div data-testid="QuotedPercentCellContainer-empty" />;
  }
  return <PercentBar percent={percent} testId="QuotedPercentCellContainer"/>
};

function resolveLiveLegs(
  thisTrade: any,
  params: any,
  isOp: boolean,
  isER: boolean,
): any[] | null {
  if (!thisTrade) return null;

  if (!isOp) {
    return thisTrade.legs ?? null;
  }

  // OP: legs live under the matching counterparty
  const erId = isER
    ? params.data?.executionRequestId
    : params.data?.executionRequestId ??
      findCounterPartyIdForBlock(thisTrade, params.data?.blockId);

  const cp = findCPOnTrade(thisTrade, erId);
  return cp?.legs ?? null;
}

function findCounterPartyIdForBlock(thisTrade: any, blockId: any): any {
  if (blockId === undefined || blockId === null) return undefined;
  for (const cp of thisTrade.executionRequestCounterParties ?? []) {
    if (cp.legs?.some((leg: any) => leg.blockId == blockId)) {
      return cp.executionRequestId;
    }
  }
  return undefined;
}

export default QuotedPercentCellRenderer;
